import { render, staticRenderFns } from "./grammatikbok.vue?vue&type=template&id=c76df362&scoped=true"
import script from "./grammatikbok.vue?vue&type=script&lang=js"
export * from "./grammatikbok.vue?vue&type=script&lang=js"
import style0 from "./grammatikbok.vue?vue&type=style&index=0&id=c76df362&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c76df362",
  null
  
)

export default component.exports